
import Modal from "react-bootstrap/Modal";
import React, { Component } from "react";
import Button from "react-bootstrap/Button";
import { ManageDashboardService } from "../../../service/manage/dashboard/manage_dashboard.service";
import InsertChartIcon from '@mui/icons-material/InsertChart';
import CardBody from "../../../components/common/CardBody";
import DoughnutChart from "../charts/DoughnutChart";
import ProgressCircle from "../charts/ProgresCircle";
import BarChart from "../charts/BarChart";
import DrillChart from "../charts/DrillChart";
import FigureChart from "../charts/FigureChart";
import ReactSpinner from "react-bootstrap/Spinner";
import { Dropdown } from "react-bootstrap";
import GroupedBarChart from "../charts/GroupedBarChart";
import AreaChart from "../charts/AreaChart";

export default class StudentsStatModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            session_id: undefined,
            table_log_id: undefined,
            dashboardData: [],
            dashboardDataLoading: false,
            suitableArray:[],
            studentIntakes:undefined,
            selectedStudentIntake:undefined
        }
    }

    getChildDashboardStats = async (session_id) => {
        this.setState({ dashboardDataLoading: true });
        await ManageDashboardService.getStatistics(
            100,
            session_id,
            sessionStorage.getItem("table_log_id"),
            "viewall"
        )
        .then((res) => {
            
        this.setState({ 
            dashboardData: res.data, 
            dashboardDataLoading: false, 
            suitableArray: this.buildStatChartArray(res.data) }, () =>{
              this.fetchSuitableStudentIntake()
            });
        })
        .catch((error) => {
            this.setState({ dashboardDataLoading: false });
        });
    };

    
    buildStatChartArray = (dashboardData) => {
        const groupedData = dashboardData.reduce((acc, obj) => {
            const key = `${obj.chart_type}_${obj.chart_id}`;
            if (!acc[key]) {
            acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
        }, {});
        const arrays = Object.values(groupedData);
        const objectArray = arrays.map(arr => {
            const highestDisplayOrderObject = arr.reduce((maxObj, obj) => {
            if (!maxObj || obj.display_order > maxObj.display_order) {
                return obj;
            } else {
                return maxObj;
            }
            }, null);
            return {
                "array":arr,
                "chart_title":arr[0].chart_title,
                "chart_type":arr[0].chart_type,
                "chart_id":arr[0].chart_id,
                "display_order":highestDisplayOrderObject.display_order
            }
        })
        objectArray.sort((a, b) => a.display_order - b.display_order) 
        return objectArray
    }

    
  renderDoghnutCharts(chart_id, flg_chart_legend_x_filter=undefined) {
    const renderOuterComponent  = (Component, val_) =>{
      return <div className="row d-flex justify-content-around chart-container w-100" style={{ marginBottom: '20px' }}>
          <div className="col-lg-12 col-md-12 d-flex justify-content-center pb-md-3 pb-sm-3">
            <Component val={val_} />
          </div>
        </div> 
    }
    const constructedArray = this.state.suitableArray.map((val,index) => {
      let applyValues = val.array
      if (val.chart_type == "progress_circle"){
        applyValues = applyValues[0]
      }
      if (flg_chart_legend_x_filter){
        applyValues = applyValues.filter(item => item.flg_chart_legend_x_filter === flg_chart_legend_x_filter)
      }
      if(chart_id === val.chart_id){
        if(val.chart_type == "Statistics-bar"){
          return renderOuterComponent(BarChart, applyValues)
        }
        if(val.chart_type == "progress_circle"){
          return renderOuterComponent(ProgressCircle, applyValues) 
        }
        if(val.chart_type == "donut"){
          return renderOuterComponent(DoughnutChart, applyValues)
        }
        if(val.chart_type == "TeacherPay-info2-donut"){
          return renderOuterComponent(DoughnutChart, applyValues)
        }
        if(val.chart_type == "Revenue-info2-donut"){
          return renderOuterComponent(DoughnutChart,applyValues)
        }
        if(val.chart_type == "figure"){
            console.log('applyValues :', applyValues)
          return renderOuterComponent(FigureChart,applyValues)
        }
      }
    })
    return constructedArray
  }

    
  fetchSuitableStudentIntake = () => {
    const suitableArray_ = this.state.suitableArray?.find(item => item.chart_type === 'Statistics-bar' && item.chart_id === 1200)
    const groupedData =suitableArray_?.array.reduce((acc, obj) => {
      const key = `${obj.flg_chart_legend_x_filter}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
    if(groupedData){
      const filteredGroupedData = Object.values(groupedData)
      this.setState({
        studentIntakes : filteredGroupedData,
        selectedStudentIntake: filteredGroupedData[0]
      })
    }
  }

    componentDidUpdate(prevProps, prevState) {
        const userId = this.props.selectedStudent?.stu_id  ? this.props.selectedStudent?.stu_id : this.props.selectedStudent?.user_id
        const prevUserId = prevProps.selectedStudent?.stu_id ? prevProps.selectedStudent?.stu_id : prevProps.selectedStudent?.user_id
        if ((
            this.props.studentStatsModal !== prevProps.studentStatsModal && this.props.studentStatsModal === true) &&
            (userId !== prevUserId || this.props.selectedStudent.user_table_id !== prevProps.selectedStudent?.user_table_id)
        ) {
            this.getChildDashboardStats(
                userId,
                this.props.selectedStudent.user_table_id
            )
        }
    }

  renderStatsCharts() {
    const renderOuterComponent = (Component, val_) => {
      return (
        <div
          className="row d-flex justify-content-around chart-container w-100"
          style={{ marginBottom: "20px" }}
        >
          <div className="col-lg-12 col-md-12 d-flex justify-content-center pb-md-3 pb-sm-3">
            <Component val={val_} />
          </div>
        </div>
      );
    };
    const constructedArray = this.state.suitableArray?.map((val, index) => {
      let applyValues = val.array;
      if (val.chart_type == "Statistics-progress_circle") {
        applyValues = applyValues[0];
      }
      if (val.chart_type == "Statistics-figure") {
        return renderOuterComponent(FigureChart, applyValues);
      }
      if (val.chart_type == "Statistics-bar") {
        return renderOuterComponent(BarChart, applyValues);
      }
      if (val.chart_type == "Statistics-progress_circle") {
        return renderOuterComponent(ProgressCircle, applyValues);
      }
      if (val.chart_type == "Statistics-donut") {
        return renderOuterComponent(DoughnutChart, applyValues);
      }
      if (val.chart_type == "progress_circle") {
        return renderOuterComponent(ProgressCircle, applyValues);
      }
      if (val.chart_type == "Statistics-multibar") {
        return renderOuterComponent(GroupedBarChart, applyValues);
      }
      if (val.chart_type == "donut") {
        return renderOuterComponent(DoughnutChart, applyValues);
      }
      if (val.chart_type == "TeacherPay-info2-donut") {
        return renderOuterComponent(DoughnutChart, applyValues);
      }
      if (val.chart_type == "Revenue-info2-donut") {
        return renderOuterComponent(DoughnutChart, applyValues);
      }
      if(val.chart_type == "Statistics-Multiline"){
        return renderOuterComponent(AreaChart,applyValues)
      }
    });
    return constructedArray;
  }



    render() {
        const { dashboardData, dashboardDataLoading } = this.state;
        return (
            <div>
                <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.props.studentStatsModal}
                    onHide={() => this.props.toggleStudentStatsModal(null)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                        {" "}
                            <h3>
                                {this.props.selectedStudent?.first_name +
                                " " +
                                this.props.selectedStudent?.last_name}
                            </h3>
                        {" "}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            {dashboardData !== null && dashboardDataLoading ?
                                <ReactSpinner
                                    animation="border"
                                    role="status"
                                    style={{ display: "block", margin: "auto" }}
                                >
                                    <span className="sr-only">Loading...</span>
                                </ReactSpinner> : (
                                    <div className="col-md-12">
                                        <div className="announcement-container">
                                            <div className="pt-4 pb-3 pl-3">
                                                <p className="parent-section-title">
                                                    {" "}
                                                    <InsertChartIcon sx={{ fontSize: 28, color: this.props.iconColor }} /> Student Statistics
                                                </p>
                                            </div>
                                            <CardBody >
                                                {/* <div className="col-md-12 px-0 d-flex justify-content-center py-3">
                                                    {dashboardDataLoading ? (this.loaderSection()) : (this.renderDoghnutCharts(200))}
                                                </div> 
                                                <div className="">
                                                <Dropdown>
                                                    <Dropdown.Toggle
                                                    variant="primary"
                                                    style={{
                                                        width: "100%",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        backgroundColor: "#fff",
                                                        border: "1px solid #E4E6EF",
                                                        color: "var(--secondary-text-color)",
                                                        fontWeight: "400",
                                                        fontSize: "10px"
                                                    }}
                                                    
                                                    >
                                                    {this.state.selectedStudentIntake&&this.state.selectedStudentIntake[0]?.flg_chart_legend_x_filter}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className="w-100">
                                                    {this.state.studentIntakes && this.state.studentIntakes.map(obj => (
                                                        <Dropdown.Item
                                                        onClick={() => {this.setState({selectedStudentIntake: obj})}}
                                                        >
                                                        {obj[0].flg_chart_legend_x_filter}
                                                        </Dropdown.Item>
                                                    ))}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                </div>                        
                                                <div className="col-md-12 px-0 d-flex justify-content-center py-3">
                                                {dashboardDataLoading ? (this.loaderSection()) : (this.state.selectedStudentIntake && this.renderDoghnutCharts(1200,this.state.selectedStudentIntake[0]?.flg_chart_legend_x_filter))}
                                                </div>
                                                <div className="col-md-12 px-0 d-flex justify-content-center py-3">
                                                {dashboardDataLoading ? (this.loaderSection()) : (this.renderDoghnutCharts(1300))}
                                                </div>  */}
                                                {dashboardDataLoading ? (this.loaderSection()) : (this.renderStatsCharts())}
                                            </CardBody>
                                        </div>
                                    </div>
                                )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            id="modal-close-button"
                            style={this.props.closeBtnStyle}
                            onClick={() =>
                                this.props.toggleStudentStatsModal(null)
                            }
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}



